import angular from 'angular';
import ngFileUpload from 'ng-file-upload';

class FileUploadService {
  constructor(Upload) {
    this.Upload = Upload;
  }
}

const moduleName = 'recaps.services.FileUploadService';
let module = angular.module(moduleName, [
  ngFileUpload,
]);

module.service('FileUploadService', FileUploadService);

export default module;
